import React from 'react';
import PropTypes from 'prop-types';
import Grid from "@mui/material/Grid";
import {Link} from "react-router-dom";

import ItemName from "components/List/components/ItemName";
import {getTranslation} from "domain/helpers/translations";
import {grayColor} from "assets/jss/main";
import {capitalize} from "utils/capitalize";
import RetailerThumbnail from "./RetailerThumbnail";

RetailerNameCell.propTypes = {
    retailer: PropTypes.object.isRequired,
};

function RetailerNameCell({retailer}) {
    const translation = getTranslation(retailer);

    return (
        <Grid
            item
            container
            xs={4}
            columnSpacing={2}
            flexWrap={"nowrap"}
            alignItems={"center"}
        >
            <Grid item display={"flex"} alignItems={"center"} sx={{flexShrink: 0}}>
                {translation.logo?.contentUrl
                    ? <RetailerThumbnail link={translation.logo.contentUrl} alt={retailer["name"]} />
                    : <div style={{width: "40px", flexShrink: 0}} />
                }
            </Grid>
            <Grid item zeroMinWidth>
                <Link to={`show/${encodeURIComponent(retailer.id)}`} style={{textDecoration: 'none'}}>
                    <ItemName label={capitalize(retailer.name)} />
                </Link>
                {retailer.paymentAccount && retailer.paymentAccount.accountId &&
                    <div style={{fontSize: '12px', color: grayColor}}>
                        {retailer.paymentAccount.accountId}
                    </div>
                }
            </Grid>
        </Grid>
    );
}

export default RetailerNameCell;
